import { HomePageTile } from "slot-definitions"
import { SearchTile } from "./search-tile"

HomePageTile.plug(<SearchTile />)
